import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { componentToRx } from "react-rxk";
import { fa } from "typed-font-awesome";
import { Observable } from "rxjs";
import { SelectorSimpleFactory } from "../logic";
import { ContactoClienteEdit, ContactoClienteParams } from "app/features/general/catalogos/items/clientes/edit/componentes/contactos/edit";
import { mapMany, flatten, toObservable, nullsafe } from "keautils";
import { observeResource } from "kea-resource";

const simpleData = [
    {
        Nombre:"Rafa",
        IdRegistro: 10
    } as any
];

const ContactoSimple = SelectorSimpleFactory<models.ContactoCliente, number>([], x => x.IdRegistro, x => x.Nombre);


interface Props {
    value?: number | null;
    onChange: (x: number | undefined | null) => void;
    loading?: boolean;
    items?: Observable<models.ContactoCliente[] | undefined> | models.ContactoCliente[];
    error?: kea.FieldError;
    idDireccion: number | undefined | null;
    label?: string;
    readonly?: boolean;
}

class ContactoNoRx extends React.PureComponent<Props> {
    idDireccion = (props: Props) => props.idDireccion;
    contactosDireccion = createSelectorRx(this.idDireccion, id => id ? observeResource(resources.Cliente.ConsultarContactos, id) : Observable.from([[]]));
    itemsProp = (props: Props) => props.items;
    itemsOrig = createSelectorRx(this.itemsProp, x => x as (models.ContactoCliente[] | undefined));
    itemsEf = createSelectorRx(this.itemsOrig, this.contactosDireccion, (items, conDir) => items || conDir);

    modalManager = kea.createModalManager();
    onAgregar = async () => {
        const idDireccion = this.props.idDireccion;
        if (!idDireccion) {
            await kea.message("No se puede agregar un contacto sin dirección");
            return;
        }
        const result = await this.modalManager.showModal(ContactoClienteEdit, { idDireccion: this.props.idDireccion } as ContactoClienteParams, {} as models.ContactoCliente);
        if (result.result) {
            const id = await resources.ContactoCliente.Add({ ...result.value, IdDireccionCliente: idDireccion });
            this.props.onChange && this.props.onChange(id);
        }
    };

    onEditar = async (idContacto: number) => {
        const idDireccion = this.props.idDireccion;
        const contacto = await resources.ContactoCliente.Get(idContacto);
        const result = await this.modalManager.showModal(ContactoClienteEdit, { idDireccion: contacto.IdDireccionCliente } as ContactoClienteParams, contacto);
        if (result.result) {
            await resources.ContactoCliente.Update(result.value);
        }
    }

    render() {
        const items = this.itemsEf(this.props);
        return (
            <div>
                <ContactoSimple
                    {... this.props}
                    onAgregar={this.props.idDireccion != null ? this.onAgregar : undefined}
                    onEditar={this.props.idDireccion != null ? this.onEditar : undefined}
                    items={items} />
                {this.modalManager.component}
            </div>
        )
    }
};

export const Contacto = componentToRx(ContactoNoRx, undefined, undefined, {
    error: { ignore: { observable: true, promise: true } },
    items: { ignore: { observable: true, promise: true } },
    loading: { loading: true }
});


// WEBPACK FOOTER //
// ./app/features/selectores/items/contacto.tsx